"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../../../hooks");
const useStyles = props => {
  const {
    pxToRem,
    setEndDirection
  } = (0, _hooks.useStylesUtils)();
  const {
    view = 'default'
  } = props;
  const ccBookLastLocationButtonStyle = (0, _react.useMemo)(() => {
    const viewProps = () => {
      if (view === 'horizontal') {
        return {
          fontSize: pxToRem(16),
          padding: `${pxToRem(2)} 0`
        };
      }
      return {};
    };
    const ccBookLastLocationButtonContent = (0, _css.css)({
      ...viewProps()
    });
    const ccBookLastLocationButtonArrow = (0, _css.css)({
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%) rotate(90deg)',
      ...setEndDirection(16)
    });
    return {
      ccBookLastLocationButtonContent,
      ccBookLastLocationButtonArrow
    };
  }, [pxToRem, setEndDirection, view]);
  return {
    'cc-Book__last-location-button__content': ccBookLastLocationButtonStyle.ccBookLastLocationButtonContent,
    'cc-Book__last-location-button__arrow': ccBookLastLocationButtonStyle.ccBookLastLocationButtonArrow
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;